import { render, staticRenderFns } from "./ComponentNavbar.vue?vue&type=template&id=5dd0546a&scoped=true&"
import script from "./ComponentNavbar.vue?vue&type=script&lang=js&"
export * from "./ComponentNavbar.vue?vue&type=script&lang=js&"
import style0 from "./ComponentNavbar.vue?vue&type=style&index=0&id=5dd0546a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd0546a",
  null
  
)

export default component.exports